@if (label) {
    <div class="console-env-banner">{{ label }}</div>
}
